import { render, staticRenderFns } from "./ChangeOverTimeChart.vue?vue&type=template&id=b283c61e&scoped=true&"
import script from "./ChangeOverTimeChart.vue?vue&type=script&lang=js&"
export * from "./ChangeOverTimeChart.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOverTimeChart.vue?vue&type=style&index=0&id=b283c61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283c61e",
  null
  
)

/* custom blocks */
import block0 from "./ChangeOverTimeChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b283c61e')) {
      api.createRecord('b283c61e', component.options)
    } else {
      api.reload('b283c61e', component.options)
    }
    module.hot.accept("./ChangeOverTimeChart.vue?vue&type=template&id=b283c61e&scoped=true&", function () {
      api.rerender('b283c61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/change-over-time/ChangeOverTimeChart.vue"
export default component.exports